import { Stack, Typography } from '@mui/material';
import { SelectFilter } from '@retail/components';
import { useProductsTFunction } from '@retail/products/i18n';
import { DiscountGroup } from '@retail/products/types';

interface Props {
  discountGroups: DiscountGroup[];
  selectedDiscountGroup: number | string | null;
  isLoading?: boolean;
  selectDiscountGroup: (discountGroupId: number | string | null) => void;
  getDiscountGroupId: (discountGroup: DiscountGroup | null) => string | number | null;
}

export function SelectDiscountGroup({
  discountGroups,
  selectedDiscountGroup,
  isLoading,
  selectDiscountGroup,
  getDiscountGroupId,
}: Props) {
  const t = useProductsTFunction();

  return (
    <SelectFilter
      label={t('products.search.discountGroup.label')}
      placeholder={t('products.search.discountGroup.searchInDiscountGroup')}
      options={discountGroups}
      value={
        discountGroups.find(
          (discountGroup) => getDiscountGroupId(discountGroup) === selectedDiscountGroup
        ) ?? null
      }
      onChange={(discountGroup) => selectDiscountGroup(getDiscountGroupId(discountGroup))}
      isLoading={isLoading}
      dividers
      getOptionKey={(discountGroup) => getDiscountGroupId(discountGroup) ?? discountGroup.code}
      getOptionLabel={({ name, code }) => `${code} ${name}`}
      renderOptionContent={({ name, code }) => (
        <Stack flexDirection="row" gap={1}>
          <Typography variant="body2">{code}</Typography>
          <Typography variant="body2">{name}</Typography>
        </Stack>
      )}
    />
  );
}
